import {useState, useEffect} from 'react';
import {osName, OsTypes} from 'react-device-detect';

export type UsePlatform = {
	platform: 'mac' | 'windows' | null;
};

export const usePlatform = () => {
	const [platform, setPlatform] = useState<'mac' | 'windows' | null>(null);

	useEffect(() => {
		const isMac = osName === OsTypes.MAC_OS;
		const isWindows = osName === OsTypes.Windows;
		const detectedPlatform = isMac ? 'mac' : isWindows ? 'windows' : null;

		setPlatform(detectedPlatform);
	}, []);

	return {platform} as UsePlatform;
};
